module.exports = __webpack_public_path__ + "static/media/idms_console.929f2c4e.png";